export const technologies = [
  {
    title: 'Programming Languages',
    items: [
      {
        name: 'Python',
        icon: 'devicon-python-plain',
      },
      {
        name: 'Java',
        icon: 'devicon-java-plain',
      },
      {
        name: 'JavaScript',
        icon: 'devicon-javascript-plain',
      },
      {
        name: 'Kotlin',
        icon: 'devicon-kotlin-plain',
      },
      {
        name: 'C',
        icon: 'devicon-c-plain',
      },
      {
        name: 'C++',
        icon: 'devicon-cplusplus-plain',
      },
    ],
  },
  {
    title: 'Frameworks/Libraries',
    items: [
      {
        name: 'Django',
        icon: 'devicon-django-plain',
      },
      {
        name: 'Three.js',
        icon: 'devicon-threejs-original',
      },
      {
        name: 'ReactJs',
        icon: 'devicon-react-original',
      },
      {
        name: 'Bootstrap',
        icon: 'devicon-bootstrap-plain',
      },
      {
        name: 'Selenium',
        icon: 'devicon-selenium-original',
      },
    ],
  },
  {
    title: 'Tools',
    items: [
      {
        name: 'Android Studio',
        icon: 'devicon-androidstudio-plain',
      },
      {
        name: 'VS Code',
        icon: 'devicon-vscode-plain',
      },
      {
        name: 'Git',
        icon: 'devicon-git-plain',
      },
      {
        name: 'Github',
        icon: 'devicon-github-original',
      },
      {
        name: 'Gitlab',
        icon: 'devicon-gitlab-plain',
      },
      {
        name: 'Docker',
        icon: 'devicon-docker-plain',
      },
    ],
  },
  {
    title: 'UI/UX',
    items: [
      {
        name: 'Figma',
        icon: 'devicon-figma-plain',
      },
      {
        name: 'Adobe XD',
        icon: 'devicon-xd-plain',
      },
      {
        name: 'Photoshop',
        icon: 'devicon-photoshop-plain',
      },
      {
        name: 'Blender',
        icon: 'devicon-blender-original',
      },
      {
        name: 'Sketch',
        icon: 'devicon-sketch-line',
      },
    ],
  },
];
